module.exports = __webpack_public_path__ + "static/img/phone2.d56fec3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/phone2.png
// module id = C5Cj
// module chunks = 1